import React, { ReactNode } from 'react';
import s from './Pagination.module.less';

interface Props {
  children?: ReactNode;
}

export const IntegratedPaginationWrapper = ({ children }: Props) => <div className={s.Pagination}>{children}</div>;
